module.exports = __webpack_public_path__ + "static/media/recommendation-done@3x.9e7f5c7d.png";